export const ButtonEditTabs = {
  CONTENT: 'content',
  STYLE: 'style',
  SETTINGS: 'settings',
}

export const LinkToTypes = {
  EMAIL: 'Email',
  WEB_ADDRESS: 'Web Address',
}

export const Alignments = [
  'Center',
  'Left',
  'Right',
]

export const Widths = {
  ['Full Width']: '85%',
  ['Half Width']: '50%',
  ['No Change']: 'initial',
}

export const PixelSizes = [
  '10px',
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
]

export const SpacingSizes = {
  Tiny: '-2px',
  Small: '-1px',
  Normal: '0px',
  Large: '1px',
  ['Extra Large']: '3px',
  Jumbo: '5px',
}



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EditorCtaButtonModal/constants.js